import {IUserTicketPrize} from "../../../firebase/topics/in-game-challenges/tickets-update/user-tickets-update-topic.model.interface";
import {IServiceFactoryExtended} from "../../../service-factory-extended.interface";
import {InGameTicketPrizeType} from "../abstract/in-game-ticket-prize-types";
import {GenericPrize} from "../generic-prize";
import {InGameTicketImmediateBonusPrize} from "../immediate-bonus-prize";
import {InGameTicketNoWinPrize} from "../no-win-prize";

export class InGameTicketPrizeFactory {
    constructor(private services: IServiceFactoryExtended) {}
    
    createInGameTicketPrize(prizeRawData: IUserTicketPrize) {
        const prizeType = prizeRawData.prizeType;
        switch (prizeType) {
            case InGameTicketPrizeType.ImmediateBonus:
                return new InGameTicketImmediateBonusPrize(prizeRawData, this.services);
            case InGameTicketPrizeType.NoWin:
                return new InGameTicketNoWinPrize(prizeRawData, this.services);
            default:
                // throw new Error("Unknown prize type: " + prizeType);
                return new GenericPrize(prizeRawData, this.services);
        }
    }
}
